import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
	Box,
	Button,
	Checkbox,
	CircularProgress,
	ListItemText,
	MenuItem,
	Select,
	SelectChangeEvent,
	Typography,
} from "@mui/material";
import {
	addUserToGroups,
	ESRThunkDispatch
} from "../actions/form";
import Chip from "@mui/material/Chip";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { selectOrg } from "./Login";

export interface GroupData {
	email: string;
	displayOrg: selectOrg | Record<string, Record<string, Record<string, string[]>>>,
	closer: () => void;
}

export const UsersGroupSelection = (props: GroupData) => {
	const { email, closer } = props;

	const [user, setUser] = useCurrentUser();

	const dispatch = useDispatch<ESRThunkDispatch>();

	const [selectedOrg, setSelectedOrg] = useState<string>("");
	const [selectedGroup, setSelectedGroup] = useState<string>("");
	const [selectedUnit, setSelectedUnit] = useState<string>("");
	const [selectedRole, setSelectedRole] = useState<string>("");
	const [selectedDistrictRole, setSelectedDistrictRoles] = useState<string[]>([]);
	const [selectedDistricts, setSelectedDistricts] = useState<string[]>([]);
	const [selectedCounties, setSelectedCounties] = useState<string[]>([]);
	const [selectedCouncils, setSelectedCouncils] = useState<string[]>([]);
	const [cleanGroups, setCleanGroups] = useState<string>("[]");
	const [valid, setValid] = useState(false);

	// type selectOrg = {
	// 	[key: string]: {
	// 		[key: string]: {
	// 			[key: string]: string[];
	// 		};
	// 	};
	// };
	type selectGroups = {
		[key: string]: string[];
	};
	const county_list: selectGroups = {
		"District 1": [
			"Cook",
			"DuPage",
			"Kane",
			"Lake",
			"McHenry",
			"Will"
		],
		"District 2": [
			"Boone",
			"Carroll",
			"Henry",
			"JoDaviess",
			"Lee",
			"Ogle",
			"Rock Island",
			"Stephenson",
			"Whiteside",
			"Winnebago",
		],
		"District 3": [
			"Bureau",
			"Dekalb",
			"Ford",
			"Grundy",
			"Iroquois",
			"Kankakee",
			"Kendall",
			"LaSalle",
			"Livingston",
		],
		"District 4": [
			"Fulton",
			"Henderson",
			"Knox",
			"McDonough",
			"Marshall",
			"Mercer",
			"Peoria",
			"Putnam",
			"Stark",
			"Tazewell",
			"Warren",
			"Woodford",
		],
		"District 5": [
			"Champaign",
			"DeWitt",
			"Douglas",
			"Edgar",
			"McLean",
			"Piatt",
			"Vermilion",
		],
		"District 6": [
			"Adams",
			"Brown",
			"Cass",
			"Christian",
			"Hancock",
			"Logan",
			"Macoupin",
			"Mason",
			"Menard",
			"Montgomery",
			"Morgan",
			"Pike",
			"Sangamon",
			"Schuyler",
			"Scott",
		],
		"District 7": [
			"Clark",
			"Clay",
			"Coles",
			"Crawford",
			"Cumberland",
			"Edwards",
			"Effingham",
			"Fayette",
			"Jasper",
			"Lawrence",
			"Macon",
			"Moultrie",
			"Richland",
			"Shelby",
			"Wabash",
			"Wayne.",
		],
		"District 8": [
			"Bond",
			"Calhoun",
			"Clinton",
			"Greene",
			"Jersey",
			"Madison",
			"Marion",
			"Monroe",
			"Randolph",
			"St. Clair",
			"Washington",
		],
		"District 9": [
			"Alexander",
			"Franklin",
			"Gallatin",
			"Hamilton",
			"Hardin",
			"Jackson",
			"Jefferson",
			"Johnson",
			"Massac",
			"Perry",
			"Pope",
			"Pulaski",
			"Saline",
			"Union",
			"White",
			"Williamson",
		],
	};
	const council_list = [
		"01 Chicago",
		"02 North Shore",
		"03 Northwest",
		"04 North Central",
		"05 Central",
		"06 Southwest",
		"07 South",
		"CCDOTH",
	];
	const role_list = [
		"State",
		"Local",
		"CDB/CI",
		"Aeronautics",
		"Railroads",
	];
	let allDistricts: string[] = [];
	let allCounties: string[] = []; // district by county
	let reverseCountyList: Record<string, string> = {};
	Object.entries(county_list).map((entry) => {
		allDistricts.push(entry[0]);
		entry[1].map((c) => {
			allCounties.push(c);
			reverseCountyList[c] = entry[0];
		});
	});
	allDistricts = allDistricts.sort();
	allCounties = allCounties.sort();

	const [loading, setLoading] = useState(false);

	let cdxReplaceMap = {
		// Nice label -> value
		"CRU Architecture (notifications)": "CRU Architecture District X Role X (notifications)",
		"SIUC Supervisor (daily/weekly summary)": "D7,8,9-SIUC (daily/weekly summary)",
		"NIU Supervisor (daily/weekly summary)": "D1,2,3-NIU (daily/weekly summary)",
		"UIUC Supervisor (daily/weekly summary)": "D4,5,6-UIUC (daily/weekly summary)",
		"RSU Supervisor (daily/weekly summary)": "RSU (daily/weekly summary)",
		"RSU Phase I (notifications)": "RSU Phase I District X (notifications)",
		"RSU Phase II (notifications)": "RSU Phase II District X (notifications)",
		"RSU CDB/CI (notifications)": "RSU CDB/CI District X (notifications)",
		"NRU Supervisor (daily/weekly summary)": "NRU (daily/weekly summary)",
		"NRU Staff (notifications)": "NRU District X (notifications)",
		"CRU Supervisor (daily/weekly summary)": "CRU (daily/weekly summary)",
		"Local Roads District Supervisor (notifications)": "Local Roads District X (notifications)",
		"Local Roads Central Office (notifications)": "Local Roads Central Office District X (notifications)",
		"Local Roads District Staff (notifications)": "Local Roads District X County X (notifications)",
		"District Environmental Coordinator": "District X Environmental Coordinator",
	};
	// Add the inverse for each pair also (value -> nice label)
	Object.entries(cdxReplaceMap).map((entry) => {
		cdxReplaceMap[entry[1]] = entry[0];
	});

	const displayOrg: selectOrg = props.displayOrg;

	// const displayOrg: selectOrg = {
	// 	"Illinois Department of Transportation (IDOT)": {
	// 		"IDOT BDE": {
	// 			"CO-BDE": ["CO-BDE (no summary, no notifications)"],
	// 			RSU: [
	// 				"RSU Supervisor (daily/weekly summary)",
	// 				"RSU Phase I (notifications)",
	// 				"RSU Phase II (notifications)" ,
	// 				"RSU District 1 Consultant (notifications)",
	// 				"RSU CDB/CI (notifications)",
	// 			],
	// 			NRU: [
	// 				"NRU Supervisor (daily/weekly summary)",
	// 				"NRU Staff (notifications)",
	// 				"NRU Aeronautics (notifications)",
	// 			],
	// 			CRU: [
	// 				"CRU Supervisor (daily/weekly summary)",
	// 				"CRU Archaeology (notifications)",
	// 				"CRU Architecture (notifications)",
	// 			],
	// 		},
	// 		"Local Roads": {
	// 			"N/A": [
	// 				"Local Roads District Staff (notifications)",
	// 				"Local Roads Central Office (notifications)",
	// 				"Local Roads District Supervisor (notifications)",
	// 			],
	// 		},
	// 		"District Environmental Coordinator": { "N/A": [] },
	// 		Aeronautics: {
	// 			"N/A": [
	// 				"Aeronautics (no notifications)",
	// 			],
	// 		},
	// 		Railroads: { "N/A": [] },
	// 		"CDB/CI": { "N/A": [] },
	// 		"Trained Staff": { "N/A": [] },
	// 	},
	// 	"Non-IDOT/Consultant": {
	// 		"Local Public Agency": { "N/A": [] },
	// 		Consultant: { "N/A": [] },
	// 		"IDNR": { "N/A": [] },
	// 	},
	// 	"Northern Illinois University": {
	// 		"N/A": {
	// 			"D1,2,3-NIU": [
	// 				"NIU Supervisor (daily/weekly summary)",
	// 				"NIU-Wetlands (notifications)",
	// 				"NIU-Biological Surveys (notifications)",
	// 			],
	// 		},
	// 	},
	// 	"University of Illinois": {
	// 		"N/A": {
	// 			"PRI (all surveys, no notifications)": [],
	// 			INHS: [
	// 				"UIUC Supervisor (daily/weekly summary)",
	// 				"UIUC-Wetlands (notifications)",
	// 				"UIUC-Biological Surveys (notifications)",
	// 			],
	// 			ISGS: [
	// 				"ISGS Wetlands (notifications)",
	// 				"ISGS PESA (notifications)",
	// 				"ISGS PESA Read-Only"
	// 			],
	// 			ISWS: ["ISWS (notifications)"],
	// 			ISAS: ["ISAS (notifications)"],
	// 		},
	// 	},
	// 	"Southern Illinois University": {
	// 		"N/A": {
	// 			"D7,8,9-SIUC": [
	// 				"SIUC Supervisor (daily/weekly summary)",
	// 				"SIUC-Wetlands (notifications)",
	// 				"SIUC-Biological Surveys (notifications)",
	// 			],
	// 		},
	// 	},
	// };

	const saveNewGroups = () => {
		if (cleanGroups !== "[]") {
			setLoading(true);
			Promise.resolve(
				dispatch(
					addUserToGroups(email, cleanGroups, !!user?.admin),
				)
			).finally(() => {
				setLoading(false);
				closer();
			});
		}
	};

	useEffect(() => {
		// Determine what the current selections are for group
		let cleanRole =
			selectedRole.length > 0 && selectedRole !== "N/A"
				? selectedRole.split(" (")[0]
				: selectedUnit.length > 0 &&
						selectedUnit !== "N/A" &&
						selectedRole === "N/A"
					? selectedUnit.split(" (")[0]
					: selectedGroup.length > 0 &&
							selectedGroup !== "N/A" &&
							selectedUnit === "N/A" &&
							selectedRole === "N/A"
						? selectedGroup.split(" (")[0]
						: "";

		// Check all required fields are filled to enable Sign Up
		let allOK = cleanRole.length > 0;
		if (/District X/g.test(cleanRole) && selectedDistricts.length === 0)
			allOK = false;
		if (/County X/g.test(cleanRole) && selectedCounties.length === 0)
			allOK = false;
		if (/Role X/g.test(cleanRole) && selectedDistrictRole.length === 0)
    		allOK = false;
		if (
			selectedCounties.some((v) => v === "Cook") &&
			selectedCouncils.length === 0
		)
			allOK = false;
		setValid(allOK);

		if (cleanRole.length > 0) {
			// Create clean group names
			let groupNames: string[] = [];
			if (cleanRole.includes("District X")) {
				selectedDistricts.map((dist) => {
					if(cleanRole.includes("Role X")){
						if (selectedDistrictRole.length > 0){
							selectedDistrictRole.forEach((role) => {
							groupNames.push(
								cleanRole
									.replace("District X", dist)
									.replace("Role X", role)
							);
						});
						}
					}
					else if (cleanRole.includes("County X")) {
						selectedCounties.map((cty) => {
							if (dist === "District 1" && cty === "Cook") {
								selectedCouncils.map((ccl) => {
									groupNames.push(
										cleanRole
											.replace("District X", dist)
											.replace("County X", cty) +
											" " +
											ccl,
									);
								});
							} else if (county_list[dist].includes(cty)) {
								groupNames.push(
									cleanRole
										.replace("District X", dist)
										.replace("County X", cty),
								);
							}
						});
					} else {
						groupNames.push(cleanRole.replace("District X", dist));
					}
				});
			} else {
				groupNames.push(cleanRole);
			}
			setCleanGroups(JSON.stringify(groupNames));
		} else {
			setCleanGroups("[]");
		}
	}, [
		selectedOrg,
		selectedGroup,
		selectedUnit,
		selectedRole,
		selectedCounties,
		selectedDistricts,
		selectedCouncils,
		selectedDistrictRole,
	]);

	return (
		<Box sx={{ position: "relative" }}>
			{loading && (
				<CircularProgress
					size={120}
					sx={{
						position: "absolute",
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
						margin: "auto",
					}}
				/>
			)}
			<Box>
				<Typography marginTop={4} fontSize={16} fontWeight={600}>
					Use the form below to select a role in the system.
				</Typography>
				<Select
					sx={{ mt: "24px" }}
					fullWidth
					value={selectedOrg}
					onChange={(e: SelectChangeEvent<typeof selectedOrg>) => {
						const {
							target: { value },
						} = e;
						setSelectedOrg(value);
						const possibleGroups = Object.keys(displayOrg[value]);
						if (possibleGroups.length === 1 && possibleGroups[0] === "N/A") {
							setSelectedGroup("N/A");
							setSelectedUnit("");
							setSelectedRole("");
							setSelectedDistrictRoles([]);
						} else if (possibleGroups.length === 1) {
							setSelectedGroup(possibleGroups[0]);
							setSelectedUnit("");
							setSelectedRole("");
							setSelectedDistrictRoles([]);
						} else {
							setSelectedGroup("");
							setSelectedUnit("");
							setSelectedRole("");
							setSelectedDistrictRoles([]);
						}
					}}
					displayEmpty
					renderValue={(value: any) => {
						if (value.length === 0) {
							return <Typography color="gray">Select organization</Typography>;
						} else {
							return (
								<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
									<Chip key={value} label={cdxReplaceMap[value] != undefined ? cdxReplaceMap[value] : value} />
								</Box>
							);
						}
					}}
				>
					{Object.entries(displayOrg).map((entry, index) => {
						return (
							<MenuItem key={`${index}-${entry[0]}`} value={cdxReplaceMap[entry[0]] != undefined ? cdxReplaceMap[entry[0]] : entry[0]}>
								{entry[0]}
							</MenuItem>
						);
					})}
				</Select>
			</Box>

			{selectedOrg.length > 0 && selectedGroup != "N/A" ? (
				<Box>
					<Select
						sx={{ mt: "24px" }}
						fullWidth
						value={selectedGroup}
						onChange={(e: SelectChangeEvent<typeof selectedGroup>) => {
							const {
								target: { value },
							} = e;
							setSelectedGroup(value);
							const lookupValue = cdxReplaceMap[value] != undefined ? cdxReplaceMap[value] : value;
							const possibleUnits = Object.keys(displayOrg[selectedOrg][lookupValue]);
							if (possibleUnits.length === 1 && possibleUnits[0] === "N/A") {
								setSelectedUnit("N/A");
								const possibleRoles = Object.keys(
									displayOrg[selectedOrg][lookupValue]["N/A"],
								);
								if (possibleRoles.length === 0) {
									setSelectedRole("N/A");
								}
							} else if (possibleUnits.length === 1) {
								setSelectedUnit(possibleUnits[0]);
								const possibleRoles = Object.keys(
									displayOrg[selectedOrg][lookupValue][possibleUnits[0]],
								);
								if (possibleRoles.length === 0) {
									setSelectedRole("N/A");
								} else {
									setSelectedRole("");
								}
							} else {
								setSelectedUnit("");
								setSelectedRole("");
							}
						}}
						displayEmpty
						renderValue={(value: any) => {
							if (value.length === 0) {
								return <Typography color="gray">Select role</Typography>;
							} else {
								return (
									<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
										<Chip key={value} label={cdxReplaceMap[value] != undefined ? cdxReplaceMap[value] : value} />
									</Box>
								);
							}
						}}
					>
						{Object.entries(displayOrg[selectedOrg]).map((entry, index) => {
							return (
								<MenuItem key={`${index}-${entry[0]}`} value={cdxReplaceMap[entry[0]] != undefined ? cdxReplaceMap[entry[0]] : entry[0]}>
									{entry[0]}
								</MenuItem>
							);
						})}
					</Select>
				</Box>
			) : (
				<></>
			)}

			{selectedGroup.length > 0 &&
			Object.keys(displayOrg[selectedOrg]).includes(selectedGroup) &&
			selectedUnit !== "N/A" ? (
				<Box>
					<Select
						sx={{ mt: "24px" }}
						fullWidth
						value={selectedUnit}
						onChange={(e: SelectChangeEvent<typeof selectedUnit>) => {
							const {
								target: { value },
							} = e;
							setSelectedUnit(value);
							const possibleRoles = (
								displayOrg[selectedOrg][selectedGroup][value] === undefined && cdxReplaceMap[value] !== undefined
									? displayOrg[selectedOrg][selectedGroup][cdxReplaceMap[value]]
									: displayOrg[selectedOrg][selectedGroup][value]
							);
							if (
								possibleRoles.length === 0 ||
								(possibleRoles.length === 1 && possibleRoles[0] === "N/A")
							) {
								setSelectedRole("N/A");
							} else if (possibleRoles.length === 1) {
								setSelectedRole(possibleRoles[0]);
							} else {
								setSelectedRole("");
							}
						}}
						displayEmpty
						renderValue={(value: any) => {
							if (value.length === 0) {
								return <Typography color="gray">Select unit</Typography>;
							} else {
								return (
									<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
										<Chip key={value} label={cdxReplaceMap[value] != undefined ? cdxReplaceMap[value] : value} />
									</Box>
								);
							}
						}}
					>
						{Object.entries(displayOrg[selectedOrg][selectedGroup]).map(
							(entry, index) => {
								return (
									<MenuItem key={`${index}-${entry[0]}`} value={cdxReplaceMap[entry[0]] != undefined ? cdxReplaceMap[entry[0]] : entry[0]}>
										{entry[0]}
									</MenuItem>
								);
							},
						)}
					</Select>
				</Box>
			) : (
				<></>
			)}

			{selectedUnit.length > 0 && selectedRole != "N/A" ? (
				<Box>
					<Select
						sx={{ mt: "24px" }}
						fullWidth
						value={selectedRole}
						onChange={(e: SelectChangeEvent<typeof selectedRole>) => {
							const {
								target: { value },
							} = e;
							setSelectedRole(value);
						}}
						displayEmpty
						renderValue={(value: any) => {
							if (value.length === 0) {
								return <Typography color="gray">Select role</Typography>;
							} else {
								return (
									<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
										<Chip key={value} label={cdxReplaceMap[value] != undefined ? cdxReplaceMap[value] : value} />
									</Box>
								);
							}
						}}
					>
						{displayOrg[selectedOrg][selectedGroup][selectedUnit].map(
							(entry, index) => {
								return (
									<MenuItem key={`${index}-${entry}`} value={cdxReplaceMap[entry] != undefined ? cdxReplaceMap[entry] : entry}>
										{entry}
									</MenuItem>
								);
							},
						)}
					</Select>
				</Box>
			) : (
				<></>
			)}

			<Box alignItems="center" display="flex" gap={4} >
				{/District X/g.test(selectedGroup) ||
				/District X/g.test(selectedRole) ? (
					<Box>
						<Select
							multiple
							sx={{ mt: "24px" }}
							fullWidth
							value={selectedDistricts}
							onChange={(e: SelectChangeEvent<typeof selectedDistricts>) => {
								const {
									target: { value },
								} = e;
								setSelectedDistricts(
									typeof value === "string" ? value.split(",") : value,
								);
							}}
							displayEmpty
							renderValue={(value: any) => {
								if (value.length === 0) {
									return <Typography color="gray">Select district</Typography>;
								} else {
									return (
										<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
											{value.map((val: string) => (
												<Chip key={val} label={val} />
											))}
										</Box>
									);
								}
							}}
						>
							{allDistricts.map((entry, index) => {
								return (
									<MenuItem key={`${index}-${entry}`} value={entry}>
										{entry}
									</MenuItem>
								);
							})}
						</Select>
					</Box>
				) : (
					<></>
				)}

				{/County X/g.test(selectedRole) ? (
					<Box>
						<Select
							multiple
							sx={{ mt: "24px" }}
							fullWidth
							value={selectedCounties}
							onChange={(e: SelectChangeEvent<typeof selectedCounties>) => {
								const {
									target: { value },
								} = e;
								setSelectedCounties(
									typeof value === "string" ? value.split(",") : value,
								);
							}}
							displayEmpty
							renderValue={(value: any) => {
								if (value.length === 0) {
									return <Typography color="gray">Select county</Typography>;
								} else {
									return (
										<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
											{value.map((val: string) => (
												<Chip key={val} label={val} />
											))}
										</Box>
									);
								}
							}}
						>
							{selectedDistricts.length > 0
								? allCounties.map((cty) => {
										if (selectedDistricts.includes(reverseCountyList[cty]))
											return (
												<MenuItem key={cty} value={cty}>
													{cty}
												</MenuItem>
											);
									})
								: allCounties.map((c) => {
										return (
											<MenuItem key={c} value={c}>
												{c}
											</MenuItem>
										);
									})}
						</Select>
					</Box>
				) : (
					<></>
				)}

				{/County X/g.test(selectedRole) &&
				selectedCounties.some((v) => v === "Cook") ? (
					<Box>
						<Select
							multiple
							sx={{ mt: "24px" }}
							fullWidth
							value={selectedCouncils}
							onChange={(e: SelectChangeEvent<typeof selectedCouncils>) => {
								const {
									target: { value },
								} = e;
								setSelectedCouncils(
									typeof value === "string" ? value.split(",") : value,
								);
							}}
							displayEmpty
							renderValue={(value: any) => {
								if (value.length === 0) {
									return <Typography color="gray">Select council</Typography>;
								} else {
									return (
										<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
											{value.map((val: string) => (
												<Chip key={val} label={val} />
											))}
										</Box>
									);
								}
							}}
						>
							{council_list.map((c) => {
								return (
									<MenuItem key={c} value={c}>
										{c}
									</MenuItem>
								);
							})}
						</Select>
					</Box>
				) : (
					<></>
				)}

				{(selectedRole.length > 0 && selectedRole.startsWith("CRU Architecture District X Role X") && selectedDistricts.length > 0) ? (
								<Box>
									{/* <Select
										multiple
										displayEmpty
										sx={{ mt: "26px", minWidth: 300  }}
										value={selectedDistrictRole ?? []}
										onChange={(e) => {
											const { value } = e.target;
											setSelectedDistrictRoles(typeof value === "string"? value.split(",") : value );
										}}
										renderValue={(selected) => {
											const values = selected as string[];
											if (selectedDistrictRole.length === 0) {
												return (
													<Typography color="gray">
														Select Role
													</Typography>
												);
											}

											return (
												<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
													{(selected as string[]).map((role) => (
														<Chip 
														key={role}
														label={role}
														size="small"
														/>

													))}
												</Box>
											);
										}}
									>
										{role_list.map((role) => (
											<MenuItem key={role} value={role}>
												{role}
											</MenuItem>
										))}
									</Select> */}
									<Select
										multiple
										displayEmpty
										fullWidth
										sx={{ mt: "24px"}}
										value={selectedDistrictRole}
										onChange={(e) => {
											const value = e.target.value;

											setSelectedDistrictRoles(
												typeof value === "string"
													? value.split(",")
													: value
											);
										}}
										renderValue={(selected) => {
											const values = selected as string[];

											return values.length === 0
												? (<Typography color="gray">Select role</Typography>)
												: (
													<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
														{values.map((role) => (
															<Chip
																key={role}
																label={role}
																// size="small"
															/>
														))}
													</Box>
												);
										}}
									>
										{role_list.map((role, index) => (
											<MenuItem key={index} value={role}>
												<Checkbox checked={selectedDistrictRole.includes(role)} />
												<ListItemText primary={role} />
											</MenuItem>
										))}
									</Select>
								</Box>
							) : (<></>)}
			</Box>

			<Box>
				{JSON.parse(cleanGroups).length === 0 ? (
					<></>
				) : (
					<>
						<Typography marginTop={4} fontSize={16} fontWeight={600}>
							Selected groups
						</Typography>
						<Box sx={{mt: "2", display: "flex", flexWrap: "wrap", gap: 1,}}>
							{JSON.parse(cleanGroups).map((grp: string, index: number) => {
								return <Chip key={`${index}-${grp}`} label={grp} />;
							})}
						</Box>
						<br />
					</>
				)}
			</Box>

			<Button disabled={!valid} onClick={saveNewGroups}>
				Add Groups
			</Button>
		</Box>
	);
};